module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1P0VoZDBZ7yIPUoWjGK4GY-3b19f05e16ade537e025fc697a99eea9.jpg";